import { TALENT_POOL_NAMES } from '~/enum/positions'
import { sortPositions } from '~/utils/positions'
import { useApiService } from '~/services/api'

export default {
  props: {
    emptyPositionsText: {
      type: String,
    },
    gtm: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      positions: [],
      positionsLoaded: false,
      locale: this.$i18n.locale,
      lang: this.$i18n.locale.slice(0, 2),
    }
  },

  async fetch() {
    await Promise.all([this.updateApiDb(), this.updatePositions()])
  },

  fetchKey: 'home-positions-list',

  methods: {
    orderPositions(positions) {
      const talentPoolName = TALENT_POOL_NAMES[this.$i18n.locale]

      return sortPositions(talentPoolName, positions)
    },
    async updateApiDb() {
      if (this.$route.query.update) {
        await useApiService({
          api: 'apiJobs',
          endpoint: 'jobs',
          url: '/sync',
          method: 'post',
          data: {
            locale: [this.lang],
          },
        })
      }
    },
    async updatePositions() {
      try {
        const { _embedded } = await useApiService({
          api: 'apiJobs',
          endpoint: 'jobs',
          url: '/find',
          params: {
            locale: 'es,pt,en',
            limit: 1000,
            offset: 0,
            keywords: '',
            offices: '',
          },
        })
        this.positions = this.orderPositions(_embedded.jobs) || []
        this.positionsLoaded = true
      } catch (error) {
        const result = await useApiService({
          api: 'apiJobsExternalProvider',
          endpoint: 'jobs',
          locale: this.lang,
        })
        this.positions = this.orderPositions(result.slice(0, 9)) || []
        this.positionsLoaded = true
      }
    },
  },
}
